<template>
  <div class="category js-transition_item_common">
    <ul class="category__list">
      <li
        v-for="(item, index) in links"
        :key="item.name"
        :class="
          index == 0
            ? 'category__item js-category_item active'
            : 'category__item js-category_item'
        "
        v-on:click="onClick($event, item.name)"
      >
        <span>{{ item.renderName }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import $ from "jquery";
import gsap from "gsap";

export default {
  data() {
    return {
      links: [
        { name: "All", renderName: "All" },
        { name: "Studio", renderName: "Studio" },
        { name: "Product", renderName: "Product" },
        { name: "Game", renderName: "Game" }
      ]
    };
  },
  methods: {
    onClick(e, name) {
      // categoryをactive⇆inactive切り替え
      const categorys = document.querySelectorAll(".js-category_item");
      categorys.forEach((el, i) => {
        el.classList.remove("active");
      });
      e.currentTarget.classList.add("active");

      const hoge = document.querySelectorAll(".tag__item");
      hoge.forEach(e => {
        e.classList.remove("active");
      });

      this.$store.commit("searchCategory", name);
      this.$store.commit("resetTag");
    }
  }
};
</script>

<style lang="scss" scoped>
.category {
  padding-bottom: 10px;
  &__list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    // overflow: scroll;
    flex-wrap: wrap;
  }

  &__item {
    color: #000;
    font-size: 16px;
    font-weight: 700;
    position: relative;
    cursor: pointer;
    margin-top: 10px;

    span {
      white-space: nowrap;
    }

    &:not(:last-child) {
      margin-right: 40px;
    }

    &:after {
      content: "";
      display: block;
    }

    &:after {
      content: "";
      width: 100%;
      left: 0;
      bottom: 0;
      height: 1px;
      background: #707070;
      position: absolute;
      transform-origin: right;
      transform: scaleX(0);
      transition: transform 0.5s $easeOutExpo;
    }

    @include min(769) {
      &:hover {
        &:after {
          transform-origin: left;
          transform: scaleX(1);
        }
      }
    }

    &.active {
      opacity: 0.4;

      &:after {
        transform: scaleX(1);
        transform-origin: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Category/_index.vue